import { Line } from "vue-chartjs";
import fsg from "@/api/base";

export default {
  name: "area-chart-day",
  extends: Line,
  data() {
    return {
      gradient: null,
      gradient1: null,
      gradient2: null,
      gradient3: null,
      label: null,
    };
  },
  props: {
    resp: Object,
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient1 = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient3 = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

    this.gradient1.addColorStop(0, "#FCF3CF");
    this.gradient1.addColorStop(0.5, "#F9E79F");
    this.gradient1.addColorStop(1, "#F7DC6F");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

    this.gradient3.addColorStop(0, "#e6eaee");
    this.gradient3.addColorStop(0.5, "#d4dbe3");
    this.gradient3.addColorStop(1, "#c6ced6");

    fsg.get("/saleprojectday")
        .then(resp => {
          this.renderChart(
              {
                labels: resp.data.message.label,
                datasets: [
                  {
                    label: "JSC",
                    borderColor: "#FC2525",
                    pointBackgroundColor: "white",
                    borderWidth: 1,
                    pointBorderColor: "white",
                    backgroundColor: this.gradient,
                    data: resp.data.message.jsc
                  },
                  {
                    label: "FSG",
                    borderColor: "#05CBE1",
                    pointBackgroundColor: "white",
                    pointBorderColor: "white",
                    borderWidth: 1,
                    backgroundColor: this.gradient1,
                    data: resp.data.message.fsg
                  },
                  {
                    label: "HTV",
                    borderColor: "#f0ad4e",
                    pointBackgroundColor: "white",
                    pointBorderColor: "white",
                    borderWidth: 1,
                    backgroundColor: this.gradient2,
                    data: resp.data.message.htv
                  },
                  {
                    label: "TOTAL",
                    borderColor: "#4e54c8",
                    pointBackgroundColor: "white",
                    pointBorderColor: "white",
                    borderWidth: 1,
                    backgroundColor: this.gradient3,
                    data: resp.data.message.all
                  }
                ]
              },
              { responsive: true, maintainAspectRatio: false }
          );
        })
  }
};